/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import React, {useCallback, useEffect, useState} from 'react';
import {toast} from 'react-toastify';
import Swal from 'sweetalert2';
import * as Yup from 'yup';
import {validate} from 'cnpj';
import Modal from 'react-bootstrap/Modal';
import Button from '../../../components/Button';
import api from '../../../services/api';
import FullPageLoader from '../../../components/FullPageLoader';
import {InsuranceProps} from '../../../interfaces';
import InputLabel from '../../../components/InputLabel';
import InputLabelOnlyNumbers from '../../../components/InputLabelOnlyNumbers';
import InputLabelCNPJnoSearch from '../../../components/InputLabelCNPJnoSearch';
import helperTooltips from '../../../data/help';
import getChanges from '../../../utils/getChanges';

interface Props {
    data: InsuranceProps;
    hide: () => void;
    refresh: () => void;
}

const validations = Yup.object().shape({
    corporate_name: Yup.string()
        .max(30, 'Deve conter no máximo 30 caracteres!')
        .required('Campo obrigatório!'),
    policy: Yup.string()
        .required('Campo obrigatório!')
        .max(20, 'Máximo de 20 caracteres')
        .nullable(),
    cpf_cnpj: Yup.string()
        .required('Campo obrigatório!')
        .test('cnpj', 'CNPJ inválido.', (value) => {
            if (value && value !== '00.000.000/0000-00') {
                return validate(value);
            }
            return true;
        })
});

const ModalForm: React.FC<Props> = ({data, hide, refresh}) => {
    const [loading, setLoading] = useState(false);

    const methods = useForm<InsuranceProps>({
        resolver: yupResolver(validations)
    });
    const {handleSubmit, reset} = methods;
    useEffect(() => {
        reset(data);
    }, [data]);

    const onSubmit = useCallback(
        async (dataSubmit: InsuranceProps) => {
            setLoading(true);
            try {
                switch (dataSubmit.form_action) {
                    case 'include':
                        await api.post('/insurances', {
                            ...dataSubmit,
                            log: {
                                corporate_name: dataSubmit.corporate_name,
                                cpf_cnpj: dataSubmit.cpf_cnpj
                            }
                        });
                        toast.success('Cadastro efetuado com sucesso');
                        break;
                    case 'edit': {
                        const log = getChanges(data, dataSubmit);
                        await api.put(`/insurances/${dataSubmit.id}`, {
                            ...dataSubmit,
                            log
                        });
                        toast.success('Cadastro alterado com sucesso');
                        break;
                    }
                    default:
                        toast.error('Erro ao efetuar cadastro');
                        break;
                }
                setLoading(false);
                refresh();
                hide();
            } catch (err: any) {
                setLoading(false);
                toast.error(err.response?.data?.errors[0]?.message);
            }
        },
        [data]
    );

    function handleCancel() {
        Swal.fire({
            title: 'Deseja realmente cancelar?',
            icon: 'question',
            showCancelButton: true,
            reverseButtons: true,
            showCloseButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.value) {
                hide();
            }
        });
    }

    return (
        <Modal show dialogAs="div" centered>
            <FormProvider {...methods}>
                <form
                    autoComplete="off"
                    onSubmit={handleSubmit(onSubmit)}
                    className="responsive-modal"
                >
                    <Modal.Dialog scrollable size="lg" centered>
                        <Modal.Header className="bg-primary">
                            <Modal.Title>
                                {data.form_action === 'include'
                                    ? 'Cadastrar Seguradora'
                                    : data.form_action === 'edit'
                                    ? 'Alterar Seguradora'
                                    : 'Visualizar Seguradora'}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="card-body p-0">
                                <div
                                    className="row"
                                    style={{
                                        justifyContent: 'start'
                                    }}
                                >
                                    <InputLabelCNPJnoSearch
                                        required
                                        label="CNPJ"
                                        name="cpf_cnpj"
                                        data_tip={helperTooltips.cnpj_insurance}
                                        size_label="2"
                                        size_input="4"
                                    />
                                </div>
                                <div
                                    className="row"
                                    style={{
                                        justifyContent: 'start'
                                    }}
                                >
                                    <InputLabel
                                        required
                                        label="Nome"
                                        name="corporate_name"
                                        data_tip={helperTooltips.name_insurance}
                                        size_label="2"
                                        size_input="10"
                                    />
                                </div>
                                <div
                                    className="row"
                                    style={{
                                        justifyContent: 'start'
                                    }}
                                >
                                    <InputLabel
                                        required
                                        label="Apólice"
                                        name="policy"
                                        data_tip={helperTooltips.policy}
                                        size_label="2"
                                        size_input="4"
                                    />

                                    <InputLabel
                                        label="Averbação"
                                        name="endorsement"
                                        data_tip={helperTooltips.endorsement}
                                        size_label="2"
                                        size_input="4"
                                    />
                                </div>
                            </div>
                            {loading && <FullPageLoader />}
                        </Modal.Body>
                        <Modal.Footer
                            style={{
                                height: 50,
                                display: 'flex',
                                alignItems: 'center',
                                alignContent: 'center'
                            }}
                        >
                            {data.form_action !== 'view' && (
                                <div className="float-left responsive-button">
                                    <Button
                                        type="button"
                                        color="danger"
                                        size="btn btn-default"
                                        icon="fa fa-arrow-circle-left"
                                        caption="Cancelar"
                                        onClick={handleCancel}
                                    />

                                    <Button
                                        type="submit"
                                        color="primary"
                                        size="btn btn-success"
                                        icon="fa fa-save"
                                        caption="Salvar"
                                        isLoading={loading}
                                        disabled={loading}
                                    />
                                </div>
                            )}
                            {data.form_action === 'view' && (
                                <div className="float-left responsive-button">
                                    <Button
                                        type="button"
                                        color="danger"
                                        size="btn btn-default"
                                        icon="fa fa-arrow-circle-left"
                                        caption="Cancelar"
                                        onClick={hide}
                                    />
                                </div>
                            )}
                        </Modal.Footer>
                    </Modal.Dialog>
                </form>
            </FormProvider>
        </Modal>
    );
};

export default ModalForm;
